import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { HttpLoadingService } from '@core/services/http-loading.service';
import {
  HTTP_BTN_LOADING_METHODS,
  HTTP_SKIP_BTN_LOADING_HEADER
} from '@core/http/http-loading.tokens';

const MUTATING = new Set<string>(HTTP_BTN_LOADING_METHODS);

/**
 * Incrémente le compteur uniquement pour POST, PUT, PATCH, DELETE
 * (`HTTP_BTN_LOADING_METHODS`), pour que `BtnHttpLoadingDirective` désactive les `.btn`.
 */
@Injectable()
export class HttpLoadingInterceptor implements HttpInterceptor {
  constructor(private _httpLoading: HttpLoadingService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this._shouldTrack(request)) {
      return next.handle(request);
    }

    this._httpLoading.begin();
    return next.handle(request).pipe(finalize(() => this._httpLoading.end()));
  }

  private _shouldTrack(request: HttpRequest<unknown>): boolean {
    if (request.headers.has(HTTP_SKIP_BTN_LOADING_HEADER)) {
      return false;
    }
    return MUTATING.has(request.method);
  }
}
